import { useEffect, useState } from "react";
import {
  getCompanyCouriersDDL,
  getLocationDDL,
  getProductDDL,
  getTeamsDDLOFFeature,
} from "../../../common/utils/dropDown";
import { GetCompanySensors } from "../../../api's/settings";

export const useBulkUploadData = (token, apiResponse) => {
  const [data, setData] = useState(apiResponse.data);
  const [couriersList, setCouriersList] = useState([]);
  const [sensorsList, setSensorsList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [allTeams, setAllTeams] = useState([]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      const [teams, couriers, sensorsRes, products, locations] =
        await Promise.all([
          getTeamsDDLOFFeature(token, "BulkShipment"),
          getCompanyCouriersDDL(token),
          GetCompanySensors(token),
          getProductDDL(token),
          getLocationDDL(token),
        ]);

      if (teams?.length) setAllTeams(teams);
      if (couriers?.length) setCouriersList(couriers);
      if (products?.length) setProductList(products);
      if (locations?.length) setLocationList(locations);

      const sensorsData = sensorsRes?.data?.data;
      if (sensorsData?.is_success) setSensorsList(sensorsData?.data);
    };

    fetchDropdowns();
  }, [token]);

  return {
    data,
    setData,
    couriersList,
    sensorsList,
    locationList,
    productList,
    allTeams,
  };
};
